import AddCardIcon from "@mui/icons-material/AddCard";
import { Grid } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import * as React from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { enqueueSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const depositEndpoint = "transaction/deposit";
const { REACT_APP_ACCOUNTS_API_URL } = process.env;

export default function Deposit({ accountNum }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const axiosPrivate = useAxiosPrivate();
  const deposit = (e) => {
    setOpen(false);
    const data = new FormData(e.currentTarget);
    e.preventDefault();
    const amount = data.get("amount");
    const narration = data.get("narration");
    const currency = data.get("currency");

    axiosPrivate
      .post(`${REACT_APP_ACCOUNTS_API_URL}/${depositEndpoint}`, {
        account_number: accountNum,
        amount,
        narration,
        currency,
      })
      .then((res) => {
        if (res.status && res.status === 200) {
          enqueueSnackbar("Deposit successful.", {
            variant: "success",
          });
        }
      })
      .catch((err) => {
        return enqueueSnackbar(`${err.response.data.apiErrors[0].cause}`, {
          variant: "error",
        });
      });
  };

  return (
    <Grid
      item
      xs={12}
      lg={12}
      md={12}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Paper>
        <div>
          <Button onClick={handleOpen} startIcon={<AddCardIcon />}></Button>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open}>
              <Box sx={style}>
                <Typography
                  id="deposit-form"
                  variant="h6"
                  component="h2"
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Enter Details
                </Typography>

                <Box
                  mt={2}
                  sx={{
                    width: 500,
                    maxWidth: "100%",
                    m: 1,
                  }}
                  component="form"
                  onSubmit={deposit}
                >
                  <Grid container direction={"column"} spacing={2}>
                    <Grid item>
                      <TextField
                        fullWidth
                        required
                        label="Amount"
                        id="amount"
                        name="amount"
                        type="number"
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        fullWidth
                        required
                        label="Narration"
                        id="narration"
                        name="narration"
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        required
                        fullWidth
                        label="Currency"
                        id="currency"
                        name="currency"
                        defaultValue={"ZMW"}
                      />
                    </Grid>
                    <Grid
                      item
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        type="submit"
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        variant="contained"
                        startIcon={<AddCardIcon />}
                      >
                        Deposit
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Fade>
          </Modal>
        </div>
      </Paper>
    </Grid>
  );
}
